export const REPORTS_ROWS_PER_PAGE = 20;
export const REPORTS_NO_FILTERS_TO_SHOW = 'No hay parámetros para filtrar';
